if (!customElements.get('ae-product-reviews')) {
  customElements.define('ae-product-reviews', class extends HTMLElement {
    connectedCallback() {
      this.loadFontsWhenVisible();
      if (this.initialized) return;
      this.initialized = true;
      this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
      this.button = this.querySelector('[data-review-more]');
      this.status = this.querySelector('[data-review-status]');
      this.visibleCount = Number(this.dataset.initial) || 3;
      this.step = Number(this.dataset.step) || 3;
      this.update();
      this.button?.addEventListener('click', () => {
        const firstNew = this.cards[this.visibleCount];
        this.visibleCount += this.step;
        this.update();
        firstNew?.focus({ preventScroll: true });
      });
    }

    loadFontsWhenVisible() {
      const styles = this.closest('.ae-reviews-container')?.querySelector('[data-ae-review-fonts]');
      if (!styles || styles.media === 'all') return;
      const load = () => {
        styles.media = 'all';
        this.fontObserver?.disconnect();
      };
      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }
      this.fontObserver?.disconnect();
      this.fontObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: '300px 0px' });
      this.fontObserver.observe(this);
    }

    disconnectedCallback() {
      this.fontObserver?.disconnect();
    }

    update() {
      const shown = Math.min(this.visibleCount, this.cards.length);
      this.cards.forEach((card, index) => { card.hidden = index >= shown; });
      if (this.button) this.button.hidden = shown >= this.cards.length;
      if (this.status) this.status.textContent = `Showing ${shown} of ${this.cards.length} ${this.dataset.noun || 'reviews'}`;
    }
  });
}
